import {
  SubCategoriesActions,
  ESubCategoriesActions,
} from "../actions/sub-category.actions";
import {
  initialSubCategoriesState,
  ISubCategoriesState,
} from "../states/sub-category.state";

export const SubCategoriesReducers = (
  state = initialSubCategoriesState,
  action: SubCategoriesActions
): ISubCategoriesState => {
  switch (action.type) {
    case ESubCategoriesActions.GetSubCategoriesSuccess: {
      return {
        ...state,
        SubCategories: { ...action.payload },
      };
    }
    default:
      return state;
  }
};
